import { useState } from "react";
import { useForm } from "react-hook-form";
import { DeclineFormInputData, IMedCard, IdentCard } from "../../types";
import { updateDocumentRequest } from "../../../../services/DriverCardService";
import { useAppSelector } from "../../../../store/hooks/redux";



export const useMedDrawerModel = (defaultValues: any) => {
    const { currentApiUrl } = useAppSelector(state => state.appReducer)

    const [isOpen, setOpen] = useState(false);

    const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        setOpen(open);
    };
    const {
        formState,
        getFieldState,
         handleSubmit,
          reset,
           control, setValue, register, getValues, setError, clearErrors, formState: { errors }, watch } = useForm<any>({
        defaultValues: defaultValues,
    });


    const updateIdentCard = async (data: IdentCard) => {
        try {
            if (currentApiUrl) {
              const response = await updateDocumentRequest(currentApiUrl, data);
              console.log(response)
              const updatedData = response.data;
              return updatedData;
            }
        } catch (e) {
            console.log(e)
        }
    }

    return {
        getFieldState,
        isOpen,
        toggleDrawer,
        handleSubmit,
        reset,
        control,
        setValue,
        getValues,
        register,
        updateIdentCard,
        errors,
        setError,
        clearErrors,
        formState,
        watch
    }
}